import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'SaleType/All', method: 'GET', body: null, token: token })
}
